<mat-dialog-content>
	<div class="flex flex-col gap-2">
		@if(this.selectedFeedEvents.value.length) {
		<div class="flex flex-row  gap-x-2 pl-6 pt-3 pb-1 mr-6">
			<button
				(click)="this.showAll()"
				mat-raised-button
			>
				{{ 'feed.removeHiddenMulti' | translate }}
			</button>
			<button
				(click)="clearSelection()"
				[matTooltip]="'feed.clearSelection' | translate"
				mat-raised-button
			>
				<mat-icon>close</mat-icon>
			</button>
		</div>
		}
		<div
			[class.brd-b]="!last"
			*ngFor="let entry of entries$ | async; let last = last; trackBy: trackId"
			class="flex flex-row items-center justify-start gap-2 py-2"
		>
			<mat-checkbox
				(change)="addToMultiselected($event.checked, entry.id)"
				(click)="$event.stopPropagation()"
				[checked]="!selectedFeedEvents.value.length ? false : checkbox.checked"
				#checkbox
				class="px-2"
			></mat-checkbox>
			<div class="flex flex-col gap-1">
				<div class="mat-typography">{{ entry.name | truncate: 100 }}</div>
				<div class="flex flex-row items-center justify-start">
					<button
						(click)="removeFromHidden(entry.id)"
						class="mat-button-small"
						mat-button
					>
						{{ 'feed.removeHidden' | translate }}
					</button>
				</div>
			</div>
			<div
				class="!ml-auto"
				style="height: 32px; width: 32px"
			>
				<img
					[src]="entry.iconUrl"
					*ngIf="entry.iconUrl != null; else msIcon"
					class="h-full"
				>
				<ng-template #msIcon>
					<ms-icon
						[icon]="entry.icon"
						class="h-full"
						style="font-size: 32px"
					></ms-icon>
				</ng-template>
			</div>
		</div>
	</div>
</mat-dialog-content>
